import { Head, Link, router } from "@inertiajs/react"
import { Box, Button, Chip, Paper, Stack, Typography } from "@mui/material"
import AdminLayout from "../../../layouts/AdminLayout"

type Translation = { id: number; language: string; text: string; hint: string | null }

type Topic = {
  id: number
  name: string
  slug: string
  summary: string | null
  jp: string | null
  banner_url: string | null
  words: { id: number; kanji: string; kana: string; translations: Translation[] }[]
  sentences: { id: number; kanji: string; kana: string; translations: Translation[] }[]
}

function primaryTranslation(translations: Translation[], language: string): string | null {
  const match = translations.find((t) => t.language === language)
  return match ? match.text : null
}

export default function ShowTopic({ topic }: { topic: Topic }) {
  const remove = () => {
    if (confirm(`Delete topic "${topic.name}"?`)) router.delete(`/admin/topics/${topic.slug}`)
  }

  return (
    <AdminLayout title={topic.name}>
      <Head title={topic.name} />
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h5">{topic.name}</Typography>
        <Stack direction="row" gap={1}>
          <Button component={Link} href={`/admin/topics/${topic.slug}/edit`}>Edit</Button>
          <Button color="error" onClick={remove}>Delete</Button>
        </Stack>
      </Stack>
      {topic.banner_url && (
        <Box sx={{ mb: 2 }}>
          <img src={topic.banner_url} alt="" style={{ maxHeight: 200, borderRadius: 8 }} />
        </Box>
      )}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">Slug</Typography>
        <Typography>{topic.slug}</Typography>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>Japanese</Typography>
        <Typography>{topic.jp || "—"}</Typography>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>Summary</Typography>
        <Typography>{topic.summary || "—"}</Typography>
      </Paper>
      <Typography variant="h6" sx={{ mt: 3 }}>Words ({topic.words.length})</Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
        {topic.words.map((w) => (
          <Chip key={w.id} label={`${w.kanji || w.kana} · ${primaryTranslation(w.translations, "en") || "—"}`}
                component={Link as any} href={`/admin/words/${w.id}`} clickable />
        ))}
      </Box>
      <Typography variant="h6" sx={{ mt: 3 }}>Sentences ({topic.sentences.length})</Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
        {topic.sentences.map((s) => (
          <Link key={s.id} href={`/admin/sentences/${s.id}`}>{s.kanji || s.kana}</Link>
        ))}
      </Box>
    </AdminLayout>
  )
}
